var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#0092E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4286 8.92857H9.57143C9.40093 8.92857 9.23742 8.9963 9.11686 9.11686C8.9963 9.23742 8.92857 9.40093 8.92857 9.57143V22.4286C8.92857 22.5991 8.9963 22.7626 9.11686 22.8831C9.23742 23.0037 9.40093 23.0714 9.57143 23.0714H22.4286C22.5991 23.0714 22.7626 23.0037 22.8831 22.8831C23.0037 22.7626 23.0714 22.5991 23.0714 22.4286V9.57143C23.0714 9.40093 23.0037 9.23742 22.8831 9.11686C22.7626 8.9963 22.5991 8.92857 22.4286 8.92857ZM9.57143 7C8.88944 7 8.23539 7.27092 7.75315 7.75315C7.27092 8.23539 7 8.88944 7 9.57143V22.4286C7 23.1106 7.27092 23.7646 7.75315 24.2468C8.23539 24.7291 8.88944 25 9.57143 25H22.4286C23.1106 25 23.7646 24.7291 24.2468 24.2468C24.7291 23.7646 25 23.1106 25 22.4286V9.57143C25 8.88944 24.7291 8.23539 24.2468 7.75315C23.7646 7.27092 23.1106 7 22.4286 7H9.57143ZM21.1429 19.6733L17.9286 16L14.7451 19.6386L12.7857 17.2857L10.8571 19.6V21.1429H21.1429V19.6733ZM14.0714 16C14.5829 16 15.0735 15.7968 15.4351 15.4351C15.7968 15.0735 16 14.5829 16 14.0714C16 13.5599 15.7968 13.0694 15.4351 12.7077C15.0735 12.346 14.5829 12.1429 14.0714 12.1429C13.5599 12.1429 13.0694 12.346 12.7077 12.7077C12.346 13.0694 12.1429 13.5599 12.1429 14.0714C12.1429 14.5829 12.346 15.0735 12.7077 15.4351C13.0694 15.7968 13.5599 16 14.0714 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/mediaIcon.a52baf0a5d0b3dec8aadcc490e2dcf35.svg";
export { ForwardRef as ReactComponent };